export enum ContentApiClientIdentifiers {
  App = 'app',
  Unknown = 'unknown',
}
